import { createAsyncThunk } from "@reduxjs/toolkit";
import { httpRequestFunc } from "../../../common/config/httpClient";
import { fetchPipelineApi } from "../../../common/api/pipelineApi";

export const fetchAsyncPipeline = createAsyncThunk(
  "pipeline/fetchAsyncPipeline",
  async (data, baseThunk) => {
    try {
      const response = await httpRequestFunc(baseThunk, fetchPipelineApi(data));
      if (response?.status == 200) {
        return response.data;
      }
    } catch (e) {}
  }
);
